import * as auth from 'external/domains/auth/passwordless/client';
export const useGetExternalUser = () => {
    const { user } = auth.state.get();
    const currentUser = {
        id: user === null || user === void 0 ? void 0 : user.sub,
        name: user === null || user === void 0 ? void 0 : user.name,
    };
    return { currentUser };
};
